import HomeIcon from 'src/assets/svg/home-icon'
import CustomerIcon from 'src/assets/svg/customer-icon'
import UserRoleIcon from 'src/assets/svg/user-role-icon'
import SubsidiaryIcon from 'src/assets/svg/subsidiary-icon'

export const sideBarData = [
    {
        title: 'Dashboard',
        path: '/dashboard/home',
        icon: (isHover: boolean) => <HomeIcon isHover={isHover}/>,
        type: 'ALL'
    },
    {
        title: 'Customers',
        path: '/dashboard/customers',
        icon: (isHover: boolean) => <CustomerIcon isHover={isHover}/>,
        type: 'INDIVIDUAL'
    },
    {
        title: 'Subsidiaries',
        path: '/dashboard/subsidiaries',
        icon: (isHover: boolean) => <SubsidiaryIcon isHover={isHover}/>,
        type: 'COMPANY'
    },
    {
        title: 'Company',
        path: '/dashboard/companies',
        icon: (isHover: boolean) => <SubsidiaryIcon isHover={isHover}/>,
        type: 'ADMIN'
    },
    {
        title: 'User Roles',
        path: '/dashboard/users',
        icon: (isHover: boolean) => <UserRoleIcon isHover={isHover}/>,
        type: 'ALL'
    },
]